import { render } from "./ui-date-selector.vue?vue&type=template&id=85b49934&ts=true"
import script from "./ui-date-selector.vue?vue&type=script&lang=ts"
export * from "./ui-date-selector.vue?vue&type=script&lang=ts"

import "./ui-date-selector.vue?vue&type=style&index=0&id=85b49934&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__